import { teacherAuthLogout } from "@/api/teacher/auth";
import { clearUserInfo } from "@/utils/userInfo";
import { clearDictCache } from "@/utils/dict";
import { clearCachedMenus } from "@/utils/dynamicMenu";
import { resetDynamicRoutes } from "@/utils/dynamicRoutes";
import { clearUserPermissions } from "@/utils/permission";
import { clearToken } from "@/utils/token";

export function clearLocalAuthState() {
  clearToken();
  clearUserInfo();
  clearDictCache();
  clearCachedMenus();
  clearUserPermissions();
  resetDynamicRoutes();
}

export async function logoutCurrentUser() {
  try {
    await teacherAuthLogout();
  } catch (e) {
    // 退出接口失败也继续清本地
  }
  clearLocalAuthState();
}



// WEBPACK FOOTER //
// ./src/utils/authLogout.js